var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "mt-5" },
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "8", lg: "6" } },
            [
              _vm.showTable
                ? _c(
                    "b-button",
                    {
                      staticClass: "mb-3",
                      attrs: { variant: "primary", block: "" },
                      on: { click: _vm.back },
                    },
                    [_vm._v(" Back ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          !_vm.showTable
            ? _c(
                "b-col",
                { attrs: { cols: "12", md: "8", lg: "6" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "shadow",
                      attrs: {
                        header: "Select Payroll Periods",
                        "header-tag": "h4",
                      },
                    },
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Period 1",
                                "label-for": "from-month-selector",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "from-month-selector",
                                  options: _vm.last12Months,
                                  placeholder: "Select from month",
                                },
                                model: {
                                  value: _vm.fromMonth,
                                  callback: function ($$v) {
                                    _vm.fromMonth = $$v
                                  },
                                  expression: "fromMonth",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Period 2",
                                "label-for": "to-month-selector",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "to-month-selector",
                                  options: _vm.last12Months,
                                  placeholder: "Select to month",
                                },
                                model: {
                                  value: _vm.toMonth,
                                  callback: function ($$v) {
                                    _vm.toMonth = $$v
                                  },
                                  expression: "toMonth",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-3",
                              attrs: { variant: "primary", block: "" },
                              on: { click: _vm.submitRange },
                            },
                            [_vm._v(" Submit ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showTable
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "shadow",
                      attrs: { header: _vm.tdsHeader, "header-tag": "h4" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mb-3",
                          attrs: { variant: "success" },
                          on: { click: _vm.exportToCSV },
                        },
                        [_vm._v(" Export to CSV ")]
                      ),
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "sm",
                          items: _vm.formattedTableData,
                          fields: _vm.tableFields,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }